// Mention éditeur — affichée en bas des pages publiques
// Conformité légale (LCEN art. 6) + crédit Osez Studio
import { Link } from 'react-router-dom';

export default function EditorCredit({ variant = 'light', className = '' }) {
  // variant: 'light' (fond clair) ou 'dark' (fond sombre)
  const isDark = variant === 'dark';
  const txtMain = isDark ? 'text-white/80' : 'text-slate-600';
  const txtMuted = isDark ? 'text-white/40' : 'text-slate-400';
  const linkClass = isDark ? 'text-white hover:text-white/90' : 'text-slate-700 hover:text-slate-900';

  return (
    <footer
      className={`w-full px-6 py-6 sm:py-8 border-t ${isDark ? 'border-white/10' : 'border-slate-200'} ${className}`}
      data-testid="editor-credit-footer"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
        {/* Crédit Osez Studio à gauche */}
        <div className={`text-[11px] sm:text-xs ${txtMain} text-center sm:text-left`}>
          <span className={txtMuted}>Édité par</span>{' '}
          <a
            href="https://osez.studio"
            target="_blank"
            rel="noreferrer noopener"
            className={`font-bold ${linkClass} underline-offset-2 hover:underline`}
            data-testid="osez-studio-link"
          >Osez Studio</a>
          <span className={txtMuted}> · SAS Market &amp; Développement · 46100 Figeac</span>
        </div>

        {/* Liens légaux à droite */}
        <nav className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] sm:text-xs ${txtMain}`}>
          <Link to="/mentions-legales" className={`${linkClass} hover:underline`} data-testid="footer-link-mentions">Mentions légales</Link>
          <Link to="/cgu" className={`${linkClass} hover:underline`} data-testid="footer-link-cgu">CGU</Link>
          <Link to="/confidentialite" className={`${linkClass} hover:underline`} data-testid="footer-link-confidentialite">Confidentialité</Link>
        </nav>
      </div>
    </footer>
  );
}
